import React from 'react';
import Translate, {t} from "../../../../../../../../components/Translate";
import Input from "../../../../../../../../components-new/form/Input";
import BlueButton from "../../../../../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import DestructiveButton from "../../../../../../../../components-new/buttons/DestructiveButton";
import Switch from "../../../../../../../../components-new/form/Switch";
import Tooltip from "../../../../../../../../components-new/general/Tooltip";
import EditSquareIcon from "../../../../../../../../assets/icons/EditSquareIcon";
import DeleteIcon from "../../../../../../../../assets/icons/DeleteIcon";

/*
 * The messages the bot opens a conversation with.
 *
 * The box and its button sat in the middle of the panel with two <br/> between
 * them and the list of messages below in 33%-wide tinted cards clipped to 60px.
 * It is a field, the button that commits it, and the messages in rows.
 *
 * Editing one loads it back into the box above - which is why the button says
 * "save" then, and why there is now a way out of that state.
 */
const InitialMessages = ({
                             handleDeleteMessage,
                             handleEditMessage,
                             toggleMessageVisibility,
                             messages,
                             newMessage,
                             handleInitialMessageInputChange,
                             handleInitialMessageKeyPress,
                             handleAddOrSaveMessage,
                             handleCancelEdit,
                             editIndex,
                             user
                         }) => (
    <div className="stg-page">
        <div className="stg-card">
            <div className="stg-card__head">
                <div>
                    <p className="stg-card__note"><Translate text="initialMessagesExplanation"/></p>
                </div>
            </div>

            <Input
                className="stg-input"
                style={{minHeight: '140px'}}
                isTextarea={true}
                resize={'vertical'}
                placeholder={t({text: "enterInitialMessageHere", user})}
                value={newMessage}
                onChange={handleInitialMessageInputChange}
                onKeyPress={handleInitialMessageKeyPress}
            />

            <div className="stg-add-row" style={{marginTop: '12px', justifyContent: 'flex-end'}}>
                {editIndex >= 0 &&
                    <SilverButton size="md" width={'120px'} onClick={handleCancelEdit}>
                        <Translate text={'cancel'}/>
                    </SilverButton>
                }

                <BlueButton
                    size="md"
                    width={'140px'}
                    onClick={handleAddOrSaveMessage}
                    disabled={!newMessage.trim()}
                >
                    <Translate text={editIndex >= 0 ? 'save' : 'add'}/>
                </BlueButton>
            </div>

            {messages.length > 0 &&
                <div className="stg-list stg-scroll" style={{marginTop: '16px'}}>
                    {messages.map((message, index) => (
                        <div
                            key={message.id}
                            className={'stg-row ' + (message.enabled ? '' : 'off')}
                        >
                            <span className="stg-row__text">{message.text}</span>

                            <div className="stg-row__actions">
                                <Switch
                                    checked={message.enabled}
                                    onChange={() => toggleMessageVisibility(message, !message.enabled)}
                                />
                                <Tooltip text="remove" deltaY={-7}>
                                    <DestructiveButton
                                        type="button"
                                        variant="outline"
                                        size="sm"
                                        iconOnly
                                        width="32px"
                                        onClick={() => handleDeleteMessage(index, message.id)}
                                    >
                                        <DeleteIcon width={18} height={18} stroke="currentColor"/>
                                    </DestructiveButton>
                                </Tooltip>
                                <Tooltip text="edit" deltaY={-7}>
                                    <SilverButton
                                        type="button"
                                        variant="soft"
                                        size="sm"
                                        iconOnly
                                        width="32px"
                                        onClick={() => handleEditMessage(index, message.id)}
                                    >
                                        <EditSquareIcon width={18} height={18} stroke="currentColor"/>
                                    </SilverButton>
                                </Tooltip>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
    </div>
);

export default InitialMessages;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/initialMessages/InitialMessages.jsx